<script>
import { AppLayout, PageHeader } from '@/components/layout'
import appConfig from '@/app.config'
import api from '@/helpers/api'
import { authComputed } from '@/state/helpers'

/**
 * Shop Component
 */
export default {
  name: 'product-detail.shop',

  page: {
    title: 'Shop',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    AppLayout,
    PageHeader
  },
  props: {
    productId: { type: String }
  },
  data: () => ({
    product: {
      sales_price: 0
    },
    isLoading: false,
    files: [],
    quantity: 1
  }),
  watch: {
    productId: {
      handler: 'onInit',
      immediate: true
    }
  },
  computed: {
    ...authComputed,
    productIsFavorite () {
      let { favorite_products = [] } = this.userProfile.preferences
        ? this.userProfile.preferences
        : {}

      return favorite_products.includes(this.productId)
    },
    titleFavoriteHover () {
      return this.productIsFavorite ? 'Unmark as favorite' : 'Mark as favorite'
    },
    title () {
      return this.product ? this.product.short_description : ''
    },
    items () {
      return [
        {
          text: 'Shop',
          to: { name: 'sales.shop' }
        },
        {
          text: this.product ? this.product.code : '',
          active: true
        }
      ]
    },
    filters () {
      return []
    },
    images () {
      return this.files.filter(f => f.type.match('image.*'))
    },
    attachments () {
      return this.files.filter(f => !f.type.match('image.*'))
    }
  },
  methods: {
    async onInit () {
      const service = this.userRole === 'admin' ? api.items : api.items

      let product = await service.fetch({
        id: this.productId
      })

      let files = []
      /*let { items: files } = await api.productFiles.fetchPage({
        page: 1,
        pageSize: -1,
        filters: [{ product_id: { _eq: this.productId } }]
      })*/

      this.product = {
        ...product
      }

      /*files.forEach(async f => {
        let { url } = await api.files.download_url({ file_id: f.file_id })
        this.files = [
          ...this.files,
          {
            ...f.file,
            name: f.file.file_name,
            size: f.file.file_size,
            type: f.file.file_content_type,
            url
          }
        ]
      })*/
    },
    async onFavoriteHanlder () {
      let { favorite_products = [] } = this.userProfile.preferences
      if (favorite_products.includes(this.productId)) {
        favorite_products = [
          ...favorite_products.filter(id => id !== this.productId)
        ]
      } else {
        favorite_products = [...favorite_products, this.productId]
      }

      let pref = await api.users.updatePreference({
        id: this.currentUser.id,
        option: 'favorite_products',
        value: favorite_products
      })

      this.$store.dispatch('auth/fetchUserProfile', { id: this.currentUser.id })
    }
  }
}
</script>

<template>
  <AppLayout>
    <PageHeader :title="title" :items="items">
      <template v-slot:title>
        <div class="d-flex align-items-center justify-content-start">
          <router-link
            :to="{ name: 'sales.shop' }"
            class="d-flex align-items-center mr-2"
            v-b-tooltip.hover.topleft
            :title="$t('Go Back')"
            ><i class="bx bx-arrow-back"></i
          ></router-link>
          <h4 class="mb-0">{{ title }}</h4>
        </div>
      </template>
    </PageHeader>
    <g-overlay :show="isLoading">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-xl-4">
                  <b-carousel :controls="images.length > 1">
                    <b-carousel-slide
                      v-for="img in images"
                      :key="img.id"
                      :img-src="img.url"
                    ></b-carousel-slide>
                    <g-no-file-image
                      v-if="images.length === 0"
                      width="100%"
                      height="350px"
                      class="border"
                    />
                  </b-carousel>
                </div>

                <div class="col-xl-8 d-flex flex-column">
                  <div>
                    <h4 class="mt-1 mb-1 d-flex align-items-center">
                      {{ product.short_description }}
                      <b-btn
                        variant="link"
                        class="p-0 mx-2 m-0"
                        v-on:click="onFavoriteHanlder"
                        v-b-tooltip.hover.right
                        :title="titleFavoriteHover"
                      >
                        <i
                          class="bx bxs-star font-size-18"
                          v-if="productIsFavorite"
                        ></i>
                        <i class="bx bx-star font-size-18" v-else></i>
                      </b-btn>
                    </h4>
                    <div class="d-flex align-items-center">
                      <h6 class="mt-1 mb-3 text-muted">
                        {{ product.code }}
                        <b-badge class="ml-1 p-1" v-if="product.item_group">
                          {{ product.item_group.description }}
                        </b-badge>
                      </h6>
                    </div>

                    <template v-if="product.is_sales_item">
                      <small class="text-muted d-block">Price</small>
                      <h5 class="d-block mb-3 text-capitalize">
                        {{ $t('unavailable') }}
                      </h5>
                    </template>
                    <template v-else>
                      <small class="text-muted d-block">Price</small>
                      <h5 class="mb-3" v-if="!product.is_sales_item">
                        {{ product.sales_price.toFixed(2)
                        }}<small class="ml-1">EUR</small>
                      </h5>
                    </template>

                    <small
                      class="text-muted mb-1"
                      v-if="product.extra_description"
                    >
                      Extra Info
                    </small>
                    <p
                      class="text-muted mb-4"
                      v-html="product.extra_description"
                    ></p>

                    <b-badge
                      v-for="(item, index) in product.tags"
                      :key="index"
                      class="d-inline mr-1"
                    >
                      {{ item }}
                    </b-badge>

                    <div class="row mb-3" v-if="false">
                      <div class="col-md-6"></div>
                    </div>
                  </div>

                  <b-row
                    no-gutters
                    align-v="center"
                    align-h="end"
                    class="mt-auto w-100"
                  >
                    <app-add-to-cart-form
                      :product-id="product.id"
                      :hideQuantity="false"
                      :product="product"
                      button-size="md"
                    />
                  </b-row>
                </div>
              </div>
              <!-- end row -->
            </div>
          </div>
          <!-- end card -->

          <b-card title="Attachments" v-if="attachments.length">
            <template v-for="img in attachments">
              <a :href="img.url" :key="img.id" target="_blank">
                <div class="d-flex flex-row align-items-center">
                  <g-file-icon
                    :content-type="img.type"
                    class="mx-2 mr-3 font-size-18"
                  />
                  <div class="flex-column">
                    {{ img.name }}
                    <small class="d-block"
                      >{{ img.size | prettyBytes }} - Last modified
                      {{ img.uploaded_at | moment('from', 'now') }}</small
                    >
                  </div>
                </div>
              </a>
            </template>
          </b-card>
        </div>
      </div>
      <!-- end row -->

      <div class="row mt-3" v-if="false">
        <div class="col-lg-12">
          <div>
            <h5 class="mb-3">Related Products :</h5>

            <div class="row">
              <div class="col-xl-4 col-sm-6">
                <div class="card">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-md-4">
                        <img
                          src="/images/product/img-7.png"
                          alt
                          class="img-fluid mx-auto d-block"
                        />
                      </div>
                      <div class="col-md-8">
                        <div class="text-center text-md-left">
                          <h5 class="mb-3 text-truncate">
                            <a href="javascript: void(0);" class="text-dark"
                              >Wirless Headphone</a
                            >
                          </h5>
                          <p class="text-muted">
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star"></i>
                          </p>
                          <h5 class="my-0">
                            <span class="text-muted mr-2">
                              <del>$240</del>
                            </span>
                            <b>$225</b>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-sm-6">
                <div class="card">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-md-4">
                        <img
                          src="/images/product/img-4.png"
                          alt
                          class="img-fluid mx-auto d-block"
                        />
                      </div>
                      <div class="col-md-8">
                        <div class="text-center text-md-left">
                          <h5 class="mb-3 text-truncate">
                            <a href="javascript: void(0);" class="text-dark"
                              >Phone patterned cases</a
                            >
                          </h5>
                          <p class="text-muted">
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star"></i>
                          </p>
                          <h5 class="my-0">
                            <span class="text-muted mr-2">
                              <del>$150</del>
                            </span>
                            <b>$145</b>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-sm-6">
                <div class="card">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-md-4">
                        <img
                          src="/images/product/img-6.png"
                          alt
                          class="img-fluid mx-auto d-block"
                        />
                      </div>
                      <div class="col-md-8">
                        <div class="text-center text-md-left">
                          <h5 class="mb-3 text-truncate">
                            <a href="javascript: void(0);" class="text-dark"
                              >Phone Dark Patterned cases</a
                            >
                          </h5>
                          <p class="text-muted">
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star text-warning"></i>
                            <i class="bx bx-star"></i>
                          </p>
                          <h5 class="my-0">
                            <span class="text-muted mr-2">
                              <del>$138</del>
                            </span>
                            <b>$135</b>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
      <!-- end row -->
    </g-overlay>
  </AppLayout>
</template>
